import React from 'react';
import { Card as AntCard, CardProps, Flex, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useThemes } from 'core';
import { ReactNode, memo } from 'react';

export interface CardComponentProps extends CardProps {
  title?: ReactNode;
  children?: ReactNode;
  extra?: ReactNode;
  isLoading?: boolean;
}

const Card = memo<CardComponentProps>(
  ({ title, extra, children, isLoading }) => {
    const { colors } = useThemes();
    return (
      <AntCard
       style={{marginBottom:'20px'}}
        headStyle={{ color: colors.white01 }}
        {...{ title }}
        aria-disabled
        bordered={false}
        extra={extra}
      >
        {isLoading && (
          <Flex
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              position: 'absolute',
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              backgroundColor: colors.black + '50',
              zIndex: 1,
            }}
            align="center"
            gap="middle"
          >
            <Spin
              indicator={
                <LoadingOutlined
                  style={{ fontSize: 34, color: colors.blue }}
                  spin
                />
              }
            />
          </Flex>
        )}
        {children}
      </AntCard>
    );
  }
);

export { Card };
